module.exports = __webpack_public_path__ + "media/photo/Component 16 – 37@2x-602ddae9.png";